module.exports = "/images/london-10.jpg";